import { setPresenceUsersIfChanged } from '@/hooks/collaboration-presence-utils';
import { readDocumentPresenceUsers, type CollaborationPresenceUser } from '@/lib/collaboration-presence';
import type { TiptapCollabProvider } from '@tiptap-pro/provider';
import { useEffect, useState } from 'react';

export type { CollaborationPresenceUser };

export function useCollaborationPresence(collabProvider: TiptapCollabProvider | null): CollaborationPresenceUser[] {
    const [users, setUsers] = useState<CollaborationPresenceUser[]>(() =>
        collabProvider ? readDocumentPresenceUsers(collabProvider) : [],
    );

    useEffect(() => {
        if (!collabProvider) {
            return;
        }

        const update = () => setPresenceUsersIfChanged(setUsers, readDocumentPresenceUsers(collabProvider));
        update();
        collabProvider.awareness?.on('update', update);

        return () => {
            collabProvider.awareness?.off('update', update);
        };
    }, [collabProvider]);

    return collabProvider ? users : [];
}
